import Vue from 'vue'
import Vuex from 'vuex'
import { ADD_TOKEN, ADD_USERID, REMOVE_COUNT } from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Current state of the application lies here.
    token: sessionStorage.getItem('token')
      ? sessionStorage.getItem('token')
      : '',
    userid: sessionStorage.getItem('userid')
      ? sessionStorage.getItem('userid')
      : ''
  },
  getters: {
    // Compute derived state based on the current state. More like computed property.
  },
  mutations: {
    // Mutate the current state
    // 写法与getters相类似
    // 组件想要对于vuex 中的数据进行的处理
    // 组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
    // 内部操作必须在此刻完成(同步)
    [ADD_TOKEN] (state, token) {
      // 第一个参数为 state 用于变更状态 登录
      sessionStorage.setItem('token', token)
      state.token = token
    },
    [ADD_USERID] (state, userid) {
      // 第一个参数为 state 用于变更状态 登录
      sessionStorage.setItem('userid', userid)
      state.userid = userid
    },
    [REMOVE_COUNT] () {
      // 退出登录
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userid')
    }
  },
  actions: {
    // Get data from server and send that to mutations to mutate the current state
  }
})
